const styles = {
  root: {
    marginBottom: 2,
    '& .MuiCardContent-root': {
      paddingTop: 0,
    },
    '& .MuiCardHeader-root': {
      paddingBottom: 1,
    },
    '& .MuiCardHeader-subheader': {
      fontSize: '12px!important',
    },
    '&.MuiCard-root': {
      backgroundColor: 'transparent',
    },
  },

  text: {
    lineHeight: '18px!important',
    fontSize: '12px!important',
  },

  rating: {
    '&.MuiRating-root .MuiRating-iconFilled': {
      color: '#e9b335!important',
    },
  },
}

export default styles
